export default "__VITE_ASSET__9cVxn2mF__"